import React, { useContext, useEffect, useState } from "react";
import ReactDOM from "react";

//import Controls from "./components/controls";
import WebServiceContext from '../../../webService/WebServiceContext'
import Menu from "../Menu";

import ProductsRank from "./ProductsRanking";
import PerformersRanking from "./PerformersRanking";
import MeetingCheck from "./MeetingCheck";
import PerformersTotal from "./PerformersTotal";
import { BasicContext } from "../../../context/BasicContext";

/**
 * 20240807
 * 處經理以及事業體模組共用
 */

type SubMenuListProps = {
    CName: string
    Groupid: string
    TabName: string
    template: string
}

type ManagerProps={
    tabName:string
}
/*
type ResultData = {
    GroupID: number 
    MenuName: string
    人力:string 
    受理業績:string 
    發薪業績:string
}*/


let sURL = new URL(window.location.href);
sURL.searchParams.get('pid');

const _d: Date = new Date()
const cy: number = _d.getFullYear() - 1911
const _a: number[] = []
for (let i: number = cy; i > cy - 10; i--) {
    _a.push(i)
}
export default (props:ManagerProps) => {
    
    const bs = useContext(BasicContext)
    const ws = useContext(WebServiceContext)
    //const [managerData, setManagerData] = useState<Manager.ManagerData[]>([])
    const [subMenu, setSubMenu] = useState<SubMenuListProps[]>([])
    //const [open, setOpen] = useState<boolean>(true) 
    //const [groupID, setGroupID] = useState<string|null>() 
    const [template, setTemplate] = useState<string|null>() 

    const sMenuHandler = (event: React.ChangeEvent<HTMLSelectElement>) => {
        //setCardData([])
        //setManagerData([])
        //getMenuContent(event.target.value as string)

        const vals:string[] =(event.target.value as string).split(","); 
        bs.setSPGroupID(vals[0])
        setTemplate(vals[1])
        console.log(vals)
        
    }

    const getMenuContent = (id: string) => {
        //setOpen(true)
        /*
        if(id == "1"){
            ws.webservice.asyncManagerReader("Dashboard_處經理2", '1', "%").then((res:any) => {
                const cdps: Manager.ManagerData[] = res as Manager.ManagerData[]

                console.log(cdps)
                setManagerData(cdps)
                //setOpen(false)
            })
        }else  if(id == "2"){
            //setOpen(false)
        }*/
    }
    /* 
    const getMenuContent = (id: string) => {
        setOpen(true)
        ws.webservice.asyncMenuContentReader("Dashboard_處經理", id).then((res:any) => {
            const cdps: Manager.ManagerData[] = res as Manager.ManagerData[]
            //console.log(cdps)
            if(id == "2"){
                //setManagerData()

                //console.log(res)
                setManagerData(
                    [{
                        GroupID:2,
                        MenuName:"歷年業績統計",
                        受理業績:cdps[0].受理業績,
                        發薪業績:cdps[0].發薪業績,
                        人力:cdps[0].人力
    
                    }  
                ]as Manager.ManagerData[])
            }else{
                setManagerData(cdps)
            }

            setOpen(false)
        })
    }
*/


    
    useEffect(() => {

        switch(props.tabName){
            case "處經理":
                //bs.setSPType("Dashboard_處經理2");
                bs.setSPType("Dashboard_處經理");
                break
            case "事業體":
                bs.setSPType("Dashboard_事業體");
                break

        }

        ws.webservice.asyncMenuChecker().then(res => {
            const sml: SubMenuListProps[] = tabNameFilter(props.tabName, res as SubMenuListProps[])
            //新增過濾分類
            setSubMenu(sml)
            
            if (sml.length > 0) {
                bs.setSPGroupID(sml[0].Groupid)
                setTemplate(sml[0].template)
            }
            //console.log(sml)
        })
        return
    }, [props.tabName])

    const tabNameFilter = (filterStr:string, source:SubMenuListProps[]):SubMenuListProps[]=>{
        let resList:SubMenuListProps[] = [];
        source.map((item:SubMenuListProps)=>{
            if(item.TabName == filterStr){
                resList.push(item)
            }
        })
        return resList;
    }
    return (
        <>
            <div className="dashboard-header">
                <div className="btns">
                    <Menu />
                </div>
                <div className="right">

                </div>
            </div>
            {
                subMenu.length > 0 &&
                <select className="hibSelect" onChange={sMenuHandler}/* disabled={open}*/>
                    {
                        subMenu.map((item: SubMenuListProps) =>
                            <option value={item.Groupid+","+item.template}  key={"sMenu_" + item.Groupid}>
                                {item.CName}
                            </option>
                        )
                    }
                </select>
            }
            <div className="cardsContainer">
                {/*
                        20240806 廢止 改用下面的template決定版型
                        groupID && groupID == "1"?
                        <ProductsRank/>
                        :
                        groupID && groupID == "2"?
                        <PerformersRanking />
                        :
                        (groupID && (groupID == "3" || groupID == "6"))?
                        <MeetingCheck groupID={groupID}/>
                        :
                        groupID && groupID == "4" ?
                        <PerformersTotal />
                        :
                        "unset"
                        
                */}
                {}
                {
                        // 20240806 template決定版型
                        template && template == "A"?
                        <ProductsRank/>
                        :
                        template && template == "B"?
                        <PerformersRanking />
                        :
                        template && template   == "C"?
                        <MeetingCheck/>
                        :
                        template && template == "D" ?
                        <PerformersTotal />
                        :
                        "unset"
                        
                }
            </div>

        </>
    )
};
